"use strict";function detectFace$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.detectFace$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.ATMBle.detectFace";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.1.18"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.1.18"},_a)),exports.detectFace$=detectFace$,exports.default=detectFace$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/ATMBle/detectFace.js
// module id = 901
// module chunks = 106